/* eslint-disable no-unused-vars */
import { Route, Routes, useNavigate } from "react-router";
import Register from "./signup";
import JamesLogo from "./../../../assets/images/james-logo2.png";
import { Link } from "react-router-dom";
import { ForgotPassword } from "./forgotPassword/forgotpassword";
import ResetPassword from "./forgotPassword/resetpassword";
import { useEffect, useState } from "react";
import API from "../../../api/handler";
import { BiErrorCircle } from "react-icons/bi";
import classNames from "classnames";
import { isEmptyString, isValidEmail } from "../../../utils/functions";
import {
  CookieData,
  JTCookies,
  createCookieDate,
} from "../../../utils/storage/cookies";
import useAPI from "../../../hooks/useApi";
import VerifyAccount from "./verifyAccount";
import { addMinutes } from "date-fns";
import JamestownWallet from "../../landing/jamestown-wallet";
import BillPayment from "../../landing/billPayment";
import DeleteAccountPage from "../../landing/DeleteAccount";
import { siteRoutes } from "../../../site/routes";

function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  );
}

export function LoginRouter(props) {
  return (
    <Routes>
      {/* Public website pages (src/site), including /login */}
      {siteRoutes}
      {/* Account screens kept from the original app */}
      <Route path="/jamestown-wallet" element={<JamestownWallet />} />
      <Route path="/bill-payment" element={<BillPayment />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />
      <Route
        path="forgotpassword"
        component={ForgotPassword}
        element={<ForgotPassword />}
      />
      <Route path="passwordreset" element={<ResetPassword />} />
      <Route path="verify-account" element={<VerifyAccount />} />
      <Route
        path="register"
        component={Register}
        element={<Register />}
      ></Route>
    </Routes>
  );
}

// function setMockAuthCookie() {
//     const expirationDate = new Date();

//     expirationDate.setHours(expirationDate.getHours() + 1);

//     const cookieString = `auth=something; expires=${expirationDate.toUTCString()}; path=/`;

//     document.cookie = cookieString;
// }

function Login() {
  const navigate = useNavigate();

  const [loginErrors, setLoginError] = useState("");

  const { loading, error, get, post } = useAPI();

  const submitLogin = async (e) => {
    e.preventDefault();

    // clear errors
    setLoginError("");

    let formData = new FormData(e.target);
    const email = formData.get("email");
    const password = formData.get("password");

    if (isValidEmail(email) && !isEmptyString(password)) {
      // handle loading

      formData.set("email", email.toLowerCase()); // convert email to lowercase

      try {
        const responseData = await post("api/v1/auth/login", formData, false);
        if (responseData["status"] === "success") {
          const data = responseData["data"];

          if (!data.isVerified) {
            localStorage.setItem("user-ph", data.phoneNumber);
            navigate("/verify-account");
          }

          const jtCookies = new JTCookies(document);
          const authCookie = new CookieData(
            "authToken",
            data["token"],
            createCookieDate(data["expiresIn"])
          );
          const emailCookie = new CookieData(
            "email",
            data["email"],
            createCookieDate(data["expiresIn"])
          );
          const timeCookie = new CookieData(
            "expiryTime",
            addMinutes(new Date(), 10).toISOString(),
            createCookieDate(data["expiresIn"])
          );

          jtCookies.saveCookies([authCookie, emailCookie, timeCookie]);

          window.location = window.location.origin; // reload the page
        } else {
          setLoginError(responseData["message"]);
        }
      } catch (error) {
        setLoginError("An error occured while trying to log in.");
        console.error(error);
      }
    } else {
      setLoginError("Invalid email or password");
    }
  };

  return (
    <div className="font-dmsans h-screen w-full flex flex-col text-center align-middle items-center bg-white">
      <div className="pt-24 flex flex-col gap-6 items-center">
        <div className="flex justify-center">
          <img src={JamesLogo} className="w-1/2" alt="logo" />
        </div>
        <div className="">
          <div className="font-bold text-[#101828] text-[30px]">
            Log in to your account
          </div>
          <div className="text-[#667085] text-[15px]">
            Welcome back! Please enter your details.
          </div>
        </div>
        <div className="font-inter">
          <div
            className={classNames(
              "w-full p-3 bg-[#ff4c4c] mb-3 rounded-lg flex text-white gap-3",
              {
                hidden: isEmptyString(loginErrors),
              }
            )}
          >
            <div className="text-[20px]">
              <BiErrorCircle />
            </div>
            <div className="space-y-1 text-[14px] font-dmsans font-medium text-start first-letter:capitalize">
              {loginErrors}
            </div>
          </div>

          <form
            method="POST"
            autoComplete="false"
            onSubmit={submitLogin}
            className="flex flex-col gap-4"
          >
            <div className="flex flex-col gap-1 items-start">
              <div className="text-[#344054] text-[14px] font-medium">
                Email
              </div>
              <div className="w-fit">
                <input
                  type="text"
                  autoComplete="false"
                  autoCorrect="false"
                  name="email"
                  className="w-[330px] border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                  placeholder="akpusugh@stown.com"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 items-start">
              <div className="text-[#344054] text-[14px] font-medium">
                Password
              </div>
              <div className="w-fit">
                <input
                  type="password"
                  name="password"
                  className="w-[330px] border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                  placeholder="Password"
                />
              </div>
            </div>
            <div className="pt-2 w-full flex">
              <button
                type="submit"
                disabled={loading}
                className={classNames(
                  `w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3`,
                  {
                    "!bg-gray-600 !text-white flex justify-center": loading,
                  }
                )}
              >
                {loading ? (
                  <div className="flex items-center gap-3">
                    <div className="expanding-loader-container">
                      <div className="expanding-loader"></div>
                    </div>
                    <div>signing in...</div>
                  </div>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
          </form>
          <div className="my-4">
            <Link
              to="/forgotpassword"
              className="text-[14px] font-medium text-[#1EA68A]"
            >
              {" "}
              Forgot password{" "}
            </Link>
          </div>
        </div>
        <div className="py-5">
          <Link
            to={"/register"}
            className="font-inter text-[14px] text-[#667085]"
          >
            Don’t have an account?{" "}
            <span className="text-[#1EA68A] font-medium">Sign up</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export { isMobileDevice };
